import React from 'react';
import { border, borders, borderRadius, boxShadow } from 'styled-system';
import { StyledComponent } from '@emotion/styled';
import { Paragraph, styled } from '@staffino/primitive-controls';

const TextPanel: StyledComponent<React.ComponentProps<typeof Paragraph>> =
  styled(Paragraph)(() => ({}), border, borders, borderRadius, boxShadow);

export default TextPanel;
